import { fmtDateTime } from "@/lib/constants";
import { Trash2, Wrench, AlertTriangle } from "lucide-react";

export function DowntimeLogList({ downtimes, canDelete, onDelete }) {
  return (
    <div className="mt-6 border-t border-slate-100 pt-5" data-testid="downtime-log-section">
      <div className="flex items-center gap-2 mb-3">
        <Wrench className="h-4 w-4 text-amber-600" />
        <h3 className="font-display text-sm font-semibold text-slate-900">Downtime Logs</h3>
        <span className="text-xs text-slate-400">· overlapping orders are flagged with capacity conflicts</span>
      </div>
      {downtimes.length === 0 ? (
        <p className="text-xs text-slate-400 italic" data-testid="downtime-empty-state">No downtime recorded for this facility.</p>
      ) : (
        <div className="space-y-2">
          {downtimes.map((d) => (
            <div key={d.id} className="flex items-center justify-between gap-3 rounded-lg border border-amber-100 bg-amber-50/50 px-3 py-2" data-testid="downtime-log-row">
              <div className="flex items-center gap-3 min-w-0">
                <AlertTriangle className="h-4 w-4 text-amber-500 shrink-0" />
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-slate-800">
                    <span className="font-mono-data">{d.line_code}</span>
                    <span className="text-slate-400 font-normal"> · {d.machine_name}</span> — {d.reason}
                  </p>
                  <p className="text-[11px] text-slate-500 font-mono-data">
                    {fmtDateTime(d.start_time)} → {fmtDateTime(d.end_time)}
                    <span className="text-slate-400 font-sans"> · logged by {d.created_by}</span>
                  </p>
                </div>
              </div>
              {canDelete && (
                <button onClick={() => onDelete(d)} className="text-slate-300 hover:text-red-600 transition-colors shrink-0" data-testid={`delete-downtime-${d.id}`}>
                  <Trash2 className="h-4 w-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
